import { z } from 'zod';
const goalEntitySchema = z.object({
    id: z.number(),
    name: z.string(),
    value: z.number()
});
const goalEntityToSaveSchema = goalEntitySchema.partial({ id: true });
export { goalEntitySchema, goalEntityToSaveSchema };
//# sourceMappingURL=projects.goal.model.js.map